
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.258 8.242l-5-5a.833.833 0 00-.266-.175.909.909 0 00-.325-.067H5a2.5 2.5 0 00-2.5 2.5v10A2.5 2.5 0 005 18h10a2.5 2.5 0 002.5-2.5V8.833a.833.833 0 00-.242-.591zM7.5 4.667h3.333v1.666H7.5V4.667zm5 11.666h-5v-2.5A.833.833 0 018.333 13h3.334a.833.833 0 01.833.833v2.5zm3.333-.833a.834.834 0 01-.833.833h-.833v-2.5a2.5 2.5 0 00-2.5-2.5H8.333a2.5 2.5 0 00-2.5 2.5v2.5H5a.834.834 0 01-.833-.833v-10A.833.833 0 015 4.667h.833v2.5A.833.833 0 006.667 8h5a.833.833 0 00.833-.833V5.842l3.333 3.333V15.5z"}})])
          )
        }
      }
    